import React, { useEffect, useState } from "react";
import ReactHtmlParser from "react-html-parser";
import { user_news_list } from "../../user/user.api";
import CustomIcons from "../../../components/icons/kIcons.component";
import "./tenders.css"; 
import BreadCrumpBack from "../../../components/navigator/back";

function Careers(props) {
  const [data, setData] = useState([]);
  const servInstance = process.env.REACT_APP_BASE_URL;
  let result = servInstance.substring(0, servInstance?.length - 4);

  useEffect(() => {
    user_news_list().then((res) => {
      setData(res?.data || []);
    });
  }, []);

  const handleNav = (linkurl) => {
    if (!linkurl) return;
    const hasProtocol = /^https?:\/\//i.test(linkurl);
    const fullUrl = hasProtocol ? linkurl : `https://${linkurl}`;
    window.open(fullUrl, "_blank");
  };

  const handleDownloadFile = (fileUrl) => {
    if (!fileUrl) return;
    const fullFileUrl = `${result}${fileUrl}`;
    window.open(fullFileUrl, "_blank");
  };

  return (
    <>
      <div className="container-fluid event-bg">
        <div className="row m-55">
          <h3>
            {props.state.language === "ma"
              ? "വാർത്തകളും അപ് ഡേറ്റുകളും"
              : "News and Updates"}
          </h3>
        </div>
        
      </div>
       <BreadCrumpBack />
      <div className="container p-50">
        <div className="bg-white">
          <div className="row tender-box">
            {data.length > 0 ? (
              data.map((item, index) => (
                <div className="bg-tender p-30" key={index}>
                  <div className="tender-title mb-2">
                    <p className="head">
                      <u>
                        {props.state.language === "ma"
                          ? item.title_ma || item.title
                          : item.title}
                      </u>
                    </p>
                  </div>

                  <div className="tender-datas">
                    <div className="col-lg-2 col-md-12 col-sm-12 label">
                      <p>
                        {props.state.language === "ma"
                          ? "വിവരണം"
                          : "Description"}
                      </p>
                    </div>
                    <div className="col-lg-10 col-md-12 col-sm-12 contentx note">
                      <p>
                        {item.description
                          ? ReactHtmlParser(
                              props.state.language === "ma"
                                ? item.description_ma || item.description_ma
                                : item.description
                            )
                          : "--"}
                      </p>
                    </div>
                  </div>

                  {item.link && item.link !== "null" && (
                    <div className="tender-datas">
                      <div className="col-lg-2 col-md-12 col-sm-12 label">
                        <p>
                          {props.state.language === "ma" ? "ലിങ്ക്" : "Link"}
                        </p>
                      </div>
                      <div className="d-flex col-lg-10 col-md-12 col-sm-12 contentx overf">
                        <p className="blink_me">
                          <CustomIcons iconName={"hand"} />
                        </p>
                        <span>
                          &nbsp;
                          <a
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              handleNav(item.link);
                            }}
                            className="break_link"
                          >
                            {props.state.language === "ma"
                              ? "ഇവിടെ ക്ലിക്ക് ചെയ്യൂ"
                              : "Click Here"}
                          </a>
                        </span>
                      </div>
                    </div>
                  )}

                  {item.file && item.file !== "storage/" && (
                    <div className="tender-datas">
                      <div className="col-lg-2 col-md-12 col-sm-12 label">
                        <p>
                          {props.state.language === "ma"
                            ? "ഡൗൺലോഡ്"
                            : "Download Document"}
                        </p>
                      </div>
                      <div className="d-flex col-lg-10 col-md-12 col-sm-12 contentx overf align-items-center">
                        <p className="blink_me">
                          <CustomIcons iconName={"hand"} />
                        </p>
                        <span>
                          &nbsp;
                          <a
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              handleDownloadFile(item.file);
                            }}
                            className="break_link"
                          >
                            {props.state.language === "ma"
                              ? "ഫയൽ ഡൗൺലോഡ് ചെയ്യൂ"
                              : "Download Document"}
                          </a>
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              ))
            ) : (
              <div className="no-data">
                <img src="resources/img/no1.png" alt="no data" />
                <h4>No Records Found..!!</h4>
              </div>
            )}
           
            {/* {data.map((card, i) => {
              return (
                <>
                  <tr>
                    <td className="m-2 text-left">{props.state.language === "ma" ? card.title_ma || card.title : card.title}</td>
                    <td className="m-2 text-left">{props.state.language === "ma" ? card.description_ma || card.description : card.description}</td>
                    {card.link && card.link !== "null"  ?
                    <td className="m-2 text-left parserfont" style={{cursor:"pointer"}} onClick={() => handleNav(card.link)}>Click Here</td> : <td></td>}
                    <td className="m-2 text-left parserfont" style={{ cursor: "pointer",color:"#0D6EFD" }} onClick={() => handleNav(card.link)}>
                      {card.link && card.link !== "null" ? (props.state.language === "ma" ? "ഇവിടെ ക്ലിക്ക് ചെയ്യൂ" : "Click Here") : ""}
                    </td>
                    {card?.file &&
                      <td className="m-2">
                        <a href={`https://kspace.inovace.in/${card.file}`} target="_blank">
                          Download File
                        </a>
                      </td>}
                    <td className="m-2">
                      {card?.file && (
                        <a href={`https://kspace.inovace.in/${card.file}`} target="_blank" rel="noopener noreferrer">
                          {props.state.language === "ma"? "ഫയൽ ഡൗൺലോഡ് ചെയ്യൂ" : "Download File"}
                        </a>
                      )}
                    </td>
                  </tr>
                </>
              );
            })} */}
        
        </div>
      </div>
      </div>
    </>
  );
}

export default Careers;
